import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FacilitatorTemplateList from '../../../manager/facilitator/new-game/list/component';
import FacilitatorTemplateDetails from '../../../manager/facilitator/new-game/template-details/component';
import Moment from 'moment';
import { checkSearchQuery } from 'helpers/checkSearchQuery';
import { setT } from 'helpers/translationUtilities';
import { gameGetTemplatesAction, gameCreateGameAction } from '../../../../redux/actions/game.actions.js';
export default function ViewFacilitatorNewGame() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var authToken = useSelector(function (state) { return state.userAuthorization.token; });
    var _a = useState(1), position = _a[0], setPosition = _a[1];
    var _b = useState(null), selectedTemplateID = _b[0], setSelectedTemplateID = _b[1];
    var _c = useState(''), newGameTitle = _c[0], setNewGameTitle = _c[1];
    var _d = useState(Moment().format('X')), newGameDate = _d[0], setNewGameDate = _d[1];
    var didUserComeFromAdminPanel = checkSearchQuery('origin', 'facilitator');
    useEffect(function () {
        dispatch(gameGetTemplatesAction(authToken));
    }, []);
    function onNext() {
        if (selectedTemplateID)
            setPosition(2);
    }
    function onBack() {
        setPosition(1);
    }
    function onExit() {
        navigate(didUserComeFromAdminPanel ? '/facilitator/games' : '/games');
    }
    function handleCreateGame() {
        if (!selectedTemplateID || !newGameTitle || !newGameDate || !authToken) {
            console.error('Error creating game', selectedTemplateID, newGameTitle, newGameDate, authToken);
            return false;
        }
        dispatch(gameCreateGameAction(selectedTemplateID, newGameTitle, newGameDate, authToken));
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "grid-row" },
            React.createElement("div", { className: "grid-sm-12" },
                React.createElement("div", { className: "general-box" },
                    React.createElement("div", { className: "topheader" },
                        React.createElement("div", { className: "topheader__primary" }, setT('add_game')),
                        React.createElement("div", { className: "infobox__subheading" }, position === 1 ? setT('select_a_template') : setT('enter_new_template_details'))),
                    position === 1 ? (React.createElement("div", null,
                        React.createElement(FacilitatorTemplateList, { onTemplateClick: setSelectedTemplateID, selectedTemplateID: selectedTemplateID }),
                        React.createElement("div", { className: "text-right" },
                            React.createElement("button", { className: "main-button main-button--generic main-button--secondary", onClick: onExit }, setT('cancel')),
                            React.createElement("button", { className: "main-button main-button--generic main-button--left", onClick: onNext }, setT('proceed'))))) : (React.createElement("div", { className: "grid-row" },
                        React.createElement("div", { className: "grid-xxl-8 grid-xl-9 grid-sm-12" },
                            React.createElement(FacilitatorTemplateDetails, { onTemplateClick: null, templateID: selectedTemplateID, onTitleChange: setNewGameTitle, onDateTimeChange: setNewGameDate })),
                        React.createElement("div", { className: "grid-xxl-8 grid-xl-9 grid-sm-12 text-right" },
                            React.createElement("button", { className: "main-button main-button--generic main-button--secondary", onClick: onBack }, setT('cancel')),
                            React.createElement("button", { className: "main-button main-button--generic main-button--left", onClick: handleCreateGame }, setT('done'))))))))));
}
